import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
const bluOceanPhotos = [{
  src: 'https://cdn.magicpatterns.com/uploads/s5KBpYMF9FCGQWRcrYkBdU/WhatsApp_Image_2026-06-16_at_14.38.01.jpg',
  alt: 'Snorkeling over a coral reef full of tropical fish'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/jybBhmRLDUa5yoRQF5y3F7/IMG-20250904-WA0046_-_copia.jpg',
  alt: 'Jet ski experience in the Caribbean'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/a1g5GonkVhvtFQstmVmPux/IMG-20251111-WA0027_-_copia.jpg',
  alt: 'Guests enjoying sunset on the boat'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7kp8Cvuk5eqA1jfRj71oHP/IMG-20250630-WA0006_-_copia.jpg',
  alt: 'Boats and floating mat at the cay'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/sUgAP8fYArxoMZxrS228QB/IMG-20250702-WA0078_-_copia.jpg',
  alt: 'Guests boarding the private boat'
}];
export function Gallery() {
  const {
    t
  } = useLanguage();
  return <section id="gallery" className="py-24 bg-white overflow-hidden" data-id="element-82">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-83">
        <div className="text-center mb-12" data-id="element-84">
          <h2 className="text-4xl font-heading font-bold text-ocean-dark mb-4" data-id="element-85">
            {t.nav.gallery}
          </h2>
          <div className="w-24 h-1 bg-turquoise mx-auto rounded-full" data-id="element-86" />
        </div>

        <div className="flex gap-4 overflow-x-auto no-scrollbar pb-4 -mx-4 px-4 snap-x snap-mandatory" data-id="element-87">
          {bluOceanPhotos.map((photo, index) => <motion.figure key={photo.src} initial={{
          opacity: 0,
          scale: 0.96
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.07,
          duration: 0.45
        }} className="relative flex-shrink-0 w-72 h-80 sm:w-80 sm:h-96 rounded-2xl overflow-hidden group snap-start shadow-lg" data-id="element-88">
              <img src={photo.src} alt={photo.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-89" />
              <div className="absolute inset-0 bg-ocean-dark/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-90" />
            </motion.figure>)}
        </div>
      </div>
    </section>;
}